import { render, staticRenderFns } from "./ResourceEditor.vue?vue&type=template&id=90d15468"
import script from "./ResourceEditor.vue?vue&type=script&lang=ts"
export * from "./ResourceEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports